function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfinity = function SvgInfinity(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M392 135.995c-33.74 0-64.22 13.92-86.02 36.33l-29.06 29.87 31.42 32.29 29.92-30.76c13.63-14.01 32.69-22.73 53.74-22.73 41.35 0 75 33.65 75 75.01 0 41.35-33.65 75-75 75-21.05 0-40.11-8.72-53.74-22.74l-132.24-135.94c-21.8-22.41-52.28-36.33-86.02-36.33-66.27 0-120 53.73-120 120.01 0 66.27 53.73 120 120 120 33.74 0 64.22-13.92 86.02-36.33l29.06-29.87-31.42-32.29-29.92 30.75c-13.63 14.02-32.69 22.74-53.74 22.74-41.35 0-75-33.65-75-75 0-41.36 33.65-75.01 75-75.01 21.05 0 40.11 8.72 53.74 22.73l132.24 135.95c21.8 22.41 52.28 36.33 86.02 36.33 66.27 0 120-53.73 120-120 0-66.28-53.73-120.01-120-120.01",
    className: "infinity_svg__st0",
    style: {
      fill: "#023e84"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfinity);
export default ForwardRef;